import React, {ChangeEvent, useEffect, useState} from "react";
import * as styled from "../../components/generalForm/GeneralFormCompStyled";
import axios from "axios";
import {useForm} from "@mantine/form";
import {showNotification} from "@mantine/notifications";
import {Button, NumberInput, Textarea, TextInput} from "@mantine/core";
import {Language} from "../../functions/CommonFunctions";
import SingleCheckboxAndText from "../checkboxComp/SingleCheckboxAndText";
import PopupComp from "../popup/PopupComp";
import CareerWorkerLightingText from "../popup/CareerWorkerLightingText";
import CareerExpressConsentText from "../popup/CareerExpressConsentText";
import Image from "next/image";


type GeneralFormCompProps = {
    title?: string;
    content?: boolean;
    textareaTitle?: string;
    textareaPlaceholder?: string;
    careerUpload?: boolean;
    pageTitle?: string;
};

const changeWriting = (e: ChangeEvent<HTMLInputElement>) => {
    // console.log(e.target.value);
}

const GeneralFormCareerComp = (props: GeneralFormCompProps) => {

        const [image, setImage] = useState(null as any);

        const [showLoading, setShowLoading] = useState(false);

        const [documentFile, setDocumentFile] = useState<string>('' as any);

        const [checked, setChecked] = React.useState(true);
        const [checkedExpress, setCheckedExpress] = React.useState(true);

        const [showPopup, setShowPopup] = React.useState(false);
        const [showPopupExpress, setShowPopupExpress] = React.useState(false);

        useEffect(() => {
            if (showPopup || showPopupExpress) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'revert-layer';
            }
        }, [showPopup, showPopupExpress]);

        const startRegistration = () => {

            if (checked && checkedExpress) {
                setShowLoading(true);
                uploadImage().then(r => {
                    setShowLoading(false);
                });
            } else {
                showNotification({
                    title: `${Language('error_message_title')}`,
                    message: `${Language('error_message_career_text')}`,
                    color: 'red',
                    autoClose: 5000,
                });
            }
        }
        const uploadImage = async () => {
            setShowLoading(true);
            const data = new FormData();
            data.append("file", image ? image : "");
            data.append(
                "upload_preset",
                'tom4cztg'
            );
            data.append("cloud_name", 'dpdt6idls');
            data.append("folder", "upload");

            axios.post(`${process.env.NEXT_PUBLIC_CLOUDINARY_URL}`, data)
                .then((response: any) => {
                    submitFormCareer.values.document = response.data.url;
                    handleSubmit(submitFormCareer.values);
                })
                .catch((error: any) => {
                    showNotification({
                        title: `${Language('error_message_title')}`,
                        message: `${Language('error_message_career')}`,
                        color: 'red',
                        autoClose: 5000,
                    });
                    setTimeout(() => {
                        setShowLoading(false);
                    }, 1000);
                });
        };

        const handleImageChange = (event: any) => {
            if (event.target.files[0] === undefined) return (
                setDocumentFile('')
            );
            setDocumentFile(event.target.files[0].name);
            const file = event.target.files[0];
            setImage(file);

            const reader = new FileReader();
            reader.readAsDataURL(file);

        };

        const setValidate = (validate: string, e: any) => {
            e.target.setCustomValidity(validate);
        }

        type FormValues = {
            email: string;
            name: string;
            about: string;
            surname: string;
            phone: string;
            document: string;
            pageTitle: string;
        }

        const submitFormCareer = useForm<FormValues>({

            initialValues: {
                email: '',
                name: '',
                about: '',
                surname: '',
                phone: '',
                document: '',
                pageTitle: props.pageTitle ? props.pageTitle : '',
            },
            validate: {
                email: value => (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i).test(value) ? null : 'Geçersiz eposta adresi',
            }
        });

        const handleSubmit = async (values: typeof submitFormCareer.values) => {
            axios.post('/api/web/submit-career', values)
                .then(function (response) {
                    showNotification({
                        title: `${Language('success_title')}`,
                        message: `${Language('success_career')}`,
                        color: 'teal',
                        autoClose: 5000,
                    });
                    setDocumentFile('');
                    setTimeout(() => {
                        setShowLoading(false);
                    }, 1000);
                })
                .catch(function (error) {
                    showNotification({
                        title: `${Language('error_message_title')}`,
                        message: `${Language('error_message_career')}`,
                        color: 'red',
                        autoClose: 5000,
                    });
                });

            submitFormCareer.setValues({
                email: '',
                name: '',
                about: '',
                surname: '',
                phone: '',
                document: '',
            });

        }


        return (
            <styled.GeneralFormContainer className={'pb-0'}>
                <styled.GeneralFormContentWrapper>
                    {props.title && (
                        <styled.GeneralFormTitle>{props.title}</styled.GeneralFormTitle>
                    )}
                </styled.GeneralFormContentWrapper>
                <styled.GeneralFormWrapper onSubmit={submitFormCareer.onSubmit(startRegistration)}>
                    <styled.GeneralFormRow>
                        <TextInput required label="İsim" className={'styled-input'} type={'text'}
                                   onInvalid={(e) => setValidate('Lütfen isminizi girin', e)}
                                   onInput={(e) => setValidate('', e)}
                                   placeholder="İsminizi girin" {...submitFormCareer.getInputProps('name')} />
                        <TextInput required className={'styled-input'}
                                   onInvalid={(e) => setValidate('Lütfen soyadınızı girin', e)}
                                   onInput={(e) => setValidate('', e)}
                                   placeholder="Soyadınızı girin" {...submitFormCareer.getInputProps('surname')} />
                    </styled.GeneralFormRow>
                    <styled.GeneralFormRow>
                        <NumberInput required label="Telefon numarası" className={'styled-input'} hideControls
                                     onInvalid={(e) => setValidate('Lütfen telefon numaranızı girin', e)}
                                     onInput={(e) => setValidate('', e)}
                                     placeholder="Telefon numaranızı girin" {...submitFormCareer.getInputProps('phone')} />
                        <TextInput required label="Email" className={'styled-input'} type={'email'}
                                   error={'Lütfen geçerli bir email adresi girin'}
                                   onInvalid={(e) => setValidate('Lütfen geçerli bir email adresi girin', e)}
                                   onInput={(e) => setValidate('', e)}
                                   placeholder="
                                    Email adresinizi girin" {...submitFormCareer.getInputProps('email')} />
                    </styled.GeneralFormRow>
                    <styled.GeneralFormRow>
                        <div className="wrapper">
                            <div className={'about'}>{props.textareaTitle}</div>
                            <Textarea required className={'styled-input-textarea'}
                                      onInvalid={(e) => setValidate('Lütfen hikayenizi yazın', e)}
                                      onInput={(e) => setValidate('', e)}
                                      placeholder={`${props.textareaPlaceholder}`} {...submitFormCareer.getInputProps('about')} />
                        </div>
                    </styled.GeneralFormRow>

                    <styled.GeneralFormRowUpload>
                        <styled.GeneralFormCVText>
                            <styled.GeneralFormCVTextTitle>
                                CV yükle
                            </styled.GeneralFormCVTextTitle>
                            <styled.GeneralFormCVTextDetail>
                                <p>
                                    Lütfen yandaki butonu kullanarak CV'nizi yükleyin.
                                </p>
                                <p>
                                    Kabul edilen formatlar: PDF, Microsoft Word
                                </p>
                            </styled.GeneralFormCVTextDetail>
                        </styled.GeneralFormCVText>
                        <styled.GeneralFormCVButton>
                            <styled.GeneralFormCVButtonText>
                                CV'nizi yüklemek için buraya tıklayın veya dosyayı sürükleyip bırakın
                            </styled.GeneralFormCVButtonText>
                            <styled.GeneralFormCVIcon>
                                <Image loading={'lazy'} width={84}
                                       height={82}
                                       sizes={'100vw'}
                                       style={{width: '84px', height: '82px'}}
                                       src={`/next/assets/images/career/upload-icon.svg`}
                                       alt={'Pembe Panjur Kariyer'} title={'Pembe Panjur Kariyer'}
                                />
                            </styled.GeneralFormCVIcon>
                            <styled.GeneralFormCVButtonTextMobile>
                                CV yükle
                            </styled.GeneralFormCVButtonTextMobile>
                            <styled.GeneralFormCVButtonInput required type={'file'} onChange={handleImageChange}
                                                             placeholder={'CV yükleyin'}
                                                             onInvalid={(e) => setValidate('Lütfen CV yükleyin', e)}
                                                             onInput={(e) => setValidate('', e)}
                                                             accept={'application/pdf, application/msword'}
                            />
                        </styled.GeneralFormCVButton>
                    </styled.GeneralFormRowUpload>
                    <styled.GeneralFormRow className={'justify-right'}>
                        {documentFile !== '' ? (
                            <styled.GeneralFormCVDocument>
                                <p>Dosya Adı: {documentFile}</p>
                            </styled.GeneralFormCVDocument>
                        ) : null}
                    </styled.GeneralFormRow>

                    <styled.GeneralFormRow className={'mt-20'}>
                        <SingleCheckboxAndText titleColor={false} checked={checked}
                                               onChange={() => setChecked(!checked)}>
                            Kişisel verilerimin işlenmesine ilişkin <button className={'lighting-button'}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                setShowPopup(!showPopup)
                                                                            }}>Aydınlatma
                            Metni</button>’ni okudum.
                        </SingleCheckboxAndText>
                        <SingleCheckboxAndText titleColor={false} checked={checkedExpress}
                                               onChange={() => setCheckedExpress(!checkedExpress)}>
                            Özgeçmişim ve iş başvuruma ilişkin kişisel verilerimin Çalışan Adaylarının Başvuru Süreçlerinin
                            Yürütülmesi amacıyla <button className={'lighting-button'}
                                                         onClick={(e) => {
                                                             e.preventDefault();
                                                             setShowPopupExpress(!showPopupExpress)
                                                         }}>Açık
                            Rıza Metni</button> kapsamında işlenmesini kabul ve beyan ediyorum.
                        </SingleCheckboxAndText>
                    </styled.GeneralFormRow>

                    <styled.GeneralFormRow className={'mb-0'}>
                        <styled.GeneralFormLine
                            style={{background: '#000'}}/>
                    </styled.GeneralFormRow>
                    <styled.GeneralFormRow className={'bgc-white'}>
                        <Button type="submit"
                                uppercase={true}
                                className={'styled-button'}
                                loading={showLoading}
                        >Başvuruyu Gönder</Button>
                    </styled.GeneralFormRow>
                </styled.GeneralFormWrapper>

                {showPopup ? (
                    <PopupComp onClose={() => setShowPopup(!showPopup)}>
                        <CareerWorkerLightingText showPopup/>
                    </PopupComp>
                ) : null}

                {showPopupExpress ? (
                    <PopupComp onClose={() => setShowPopupExpress(!showPopupExpress)}>
                        <CareerExpressConsentText showPopup/>
                    </PopupComp>
                ) : null}
            </styled.GeneralFormContainer>
        )
    }
;

export default GeneralFormCareerComp;
